import { Injectable } from '@angular/core';
import { RestApi } from 'app/auth/rest.api';
import { Observable } from 'rxjs';
import { IKBCatalog } from '../interfaces/IBase-knowledge-catalog';

@Injectable({
  providedIn: 'root'
})
export class BaseKnowledgeCatalogService {
  baseKnowledgeCatalog = 'api/BaseKnowledgeCatalog';
  constructor(private _baseKnowledgeCatalogHttp: RestApi) { }

  getBaseKnowledgeCatalog(): Observable<any> {
    return this._baseKnowledgeCatalogHttp.get(`${this.baseKnowledgeCatalog}/GetBaseKnowledgeCatalog`);
  }

  getBaseKnowledgeCatalogLearned(): Observable<any> {
    return this._baseKnowledgeCatalogHttp.get(`${this.baseKnowledgeCatalog}/GetBaseKnowledgeCatalogLearned`);
  }

  checkBaseKnowledgeFeaturesEnabled(): Observable<any> {
    return this._baseKnowledgeCatalogHttp.get(`${this.baseKnowledgeCatalog}/CheckBaseKnowledgeFeaturesEnabled`);
  }

  retryLearnedVectorization(idKBlearned: Guid): Observable<any> {
    return this._baseKnowledgeCatalogHttp.post(`${this.baseKnowledgeCatalog}/RetryLearnedVectorization?idKBlearned=${idKBlearned}`, {});
  }

  checkDisplayNameCatalogAvailable(id: string, displayName: string): Observable<any> {
    return this._baseKnowledgeCatalogHttp.get(`${this.baseKnowledgeCatalog}/CheckDisplayNameCatalogAvailable?id=${id}&displayName=${encodeURIComponent(displayName)}`);
  }

  saveCatalog(config: IKBCatalog): Observable<IKBCatalog> {
    return this._baseKnowledgeCatalogHttp.post(`${this.baseKnowledgeCatalog}/SaveKBCatalog`, config);
  }

  deleteCatalog(config: IKBCatalog): Observable<any> {
    return this._baseKnowledgeCatalogHttp.post(`${this.baseKnowledgeCatalog}/DeleteKBCatalog`, config);
  }
}
